const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const applyInlineMarkdown = (value = "") =>
  escapeHtml(value).replace(
    /\*\*(.+?)\*\*/g,
    "<strong>$1</strong>",
  );

/**
 * Lightweight markdown for career job descriptions:
 * - **bold**
 * - line breaks / paragraphs
 * - bullet lists (- or *)
 * - numbered lists (1.)
 */
export const renderJobMarkdown = (markdown = "") => {
  const text = String(markdown || "").replace(/\r\n/g, "\n").trim();
  if (!text) return "";

  const lines = text.split("\n");
  const blocks = [];
  let paragraph = [];
  let listType = null;
  let listItems = [];

  const flushParagraph = () => {
    if (!paragraph.length) return;
    const html = paragraph.map(applyInlineMarkdown).join("<br />");
    blocks.push(`<p>${html}</p>`);
    paragraph = [];
  };

  const flushList = () => {
    if (!listType || !listItems.length) {
      listType = null;
      listItems = [];
      return;
    }
    const tag = listType === "ol" ? "ol" : "ul";
    const items = listItems
      .map((item) => `<li>${applyInlineMarkdown(item)}</li>`)
      .join("");
    blocks.push(`<${tag}>${items}</${tag}>`);
    listType = null;
    listItems = [];
  };

  lines.forEach((rawLine) => {
    const line = rawLine.trimEnd();
    const bulletMatch = line.match(/^\s*[-*]\s+(.+)$/);
    const numberedMatch = line.match(/^\s*\d+\.\s+(.+)$/);

    if (bulletMatch) {
      flushParagraph();
      if (listType && listType !== "ul") flushList();
      listType = "ul";
      listItems.push(bulletMatch[1]);
      return;
    }

    if (numberedMatch) {
      flushParagraph();
      if (listType && listType !== "ol") flushList();
      listType = "ol";
      listItems.push(numberedMatch[1]);
      return;
    }

    if (!line.trim()) {
      flushParagraph();
      flushList();
      return;
    }

    flushList();
    paragraph.push(line);
  });

  flushParagraph();
  flushList();

  return blocks.join("");
};
